import { useEffect, useState } from 'react';

const usePaginationController = (elementsPerPage: number) => {
	const [currentPage, setCurrentPage] = useState(1);
	const [elementsTotal, initElementsTotal] = useState(0);

	const advancePage = () => setCurrentPage(previousPage => previousPage + 1);
	const recedePage = () => setCurrentPage(previousPage => previousPage - 1);

	/** Reset state upon dataset change */
	useEffect(() => setCurrentPage(1), [elementsTotal]);

	return { currentPage, advancePage, recedePage, elementsTotal, initElementsTotal, elementsPerPage };
};

export default usePaginationController;
